import "./Header.scss";

const Header = () => (
  <header>
    <h1>
      SPLI
      <br />
      TTER
    </h1>
  </header>
);

export default Header;
